export default __webpack_public_path__ + "static/emp-icn9-e81cb445f2e23e070e0541b61ed168ec.png";